import { Text, View } from '@react-pdf/renderer'
import PDFPage from '@/components/ReportPDF/PDFPage'

const toc = [
  { label: '第一章 本文件資訊之揭露與限制', key: 'chap1' },
  { label: '第二章 執行摘要', key: 'chap2' },
  {
    label: '第三章 介紹',
    key: 'chap3',
    subItems: [
      { label: '3.1 專案流程', key: 'chap3_1' },
      { label: '3.2 專案執行項目', key: 'chap3_2' },
      { label: '3.3 測試規範', key: 'chap3_3' },
      { label: '3.4 執行標的', key: 'chap3_4' },
      { label: '3.5 執行內容', key: 'chap3_5' },
      { label: '3.6 檢測信件樣本', key: 'chap3_6' },
    ],
  },
  {
    label: '第四章 測試分析報告',
    key: 'chap4',
    subItems: [
      { label: '4.1 受測者總結果統計', key: 'chap4_1' },
      { label: '4.2 受測者行為依樣版統計', key: 'chap4_2' },
      {
        label: '4.3 部門結果統計報表',
        key: 'chap4_3',
        subItems: [{ label: '4.3.1部門統計結果清單', key: 'chap4_3_1' }],
      },
      { label: '4.4 受測者釣中行為清單', key: 'chap4_4' },
      // {
      //   label: '4.5 廠別結果統計報表',
      //   key: 'chap4_5',
      //   subItems: [{ label: '4.5.1 廠別結果統計', key: 'chap4_5_1' }],
      // },
      // {
      //   label: '4.6 作業系統統計報表',
      //   key: 'chap4_6',
      //   subItems: [{ label: '4.6.1 作業系統統計結果清單', key: 'chap4_6_1' }],
      // },
      { label: '4.5 歷年演練結果', key: 'chap4_5' },
    ],
  },
  { label: '第五章 結論', key: 'chap5' },
]

const toc2 = [
  { label: '第一章 本文件資訊之揭露與限制', key: 'chap1' },
  { label: '第二章 執行摘要', key: 'chap2' },
  {
    label: '第三章 介紹',
    key: 'chap3',
    subItems: [
      { label: '3.1 專案流程', key: 'chap3_1' },
      { label: '3.2 專案執行項目', key: 'chap3_2' },
      { label: '3.3 測試規範', key: 'chap3_3' },
      { label: '3.4 執行標的', key: 'chap3_4' },
      { label: '3.5 執行內容', key: 'chap3_5' },
      { label: '3.6 檢測信件樣本', key: 'chap3_6' },
    ],
  },
  {
    label: '第四章 測試分析報告',
    key: 'chap4',
    subItems: [
      { label: '4.1 受測者總結果統計', key: 'chap4_1' },
      { label: '4.2 受測者行為依樣版統計', key: 'chap4_2' },
      {
        label: '4.3 部門結果統計報表',
        key: 'chap4_3',
        subItems: [{ label: '4.3.1部門統計結果清單', key: 'chap4_3_1' }],
      },
      { label: '4.4 受測者釣中行為清單', key: 'chap4_4' },
      // {
      //   label: '4.5 作業系統統計報表',
      //   key: 'chap4_5',
      //   subItems: [{ label: '4.5.1 作業系統統計結果清單', key: 'chap4_5_1' }],
      // },
      // { label: '4.6 歷年演練結果', key: 'chap4_6' },
    ],
  },
  { label: '第五章 結論', key: 'chap5' },
]

const ToCItem = ({ name, label, page, pageData, labelStyle, subItems }) => (
  <>
    <View
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', marginBottom: 10 }}
    >
      <Text style={{ ...labelStyle, fontSize: 24, fontWeight: 'bold', fontFamily: 'Noto Sans' }}>
        {label}
      </Text>
      <View
        style={{
          flex: 1,
          height: 1,
          borderBottom: '2px solid black',
          borderStyle: 'dotted',
          marginHorizontal: 5,
          marginBottom: 3,
        }}
      />
      <Text style={{ fontWeight: 'bold', fontFamily: 'Noto Sans' }}>{page - 1}</Text>
    </View>

    {subItems && (
      <View style={{ paddingLeft: 20 }}>
        {subItems.map(({ key, ...itemProps }, index) => (
          <ToCItem
            key={`${name}_${index + 1}`}
            name={`${name}_${index + 1}`}
            labelStyle={{ fontWeight: 'normal' }}
            page={pageData[key] || 0}
            pageData={pageData}
            {...itemProps}
          />
        ))}
      </View>
    )}
  </>
)

const TableOfContentsPage = ({ pageData, reportData, shouldRenderHistoriesPage }) => (
  <PDFPage title="目錄" reportData={reportData} hideTitleDivider>
    {shouldRenderHistoriesPage
      ? toc.map(({ key, ...tocProps }, index) => (
          <ToCItem
            key={`toc_${index + 1}`}
            name={`toc_${index + 1}`}
            page={pageData[key] || 0}
            pageData={pageData}
            {...tocProps}
          />
        ))
      : toc2.map(({ key, ...tocProps }, index) => (
          <ToCItem
            key={`toc_${index + 1}`}
            name={`toc_${index + 1}`}
            page={pageData[key] || 0}
            pageData={pageData}
            {...tocProps}
          />
        ))}

    {/* {toc.map(({ key, ...tocProps }, index) => (
      <ToCItem
        key={`toc_${index + 1}`}
        name={`toc_${index + 1}`}
        page={pageData[key] || 0}
        pageData={pageData}
        {...tocProps}
      />
    ))} */}
  </PDFPage>
)

export default TableOfContentsPage
